// extracted by mini-css-extract-plugin
module.exports = {"button":"colorblock_button__2g_NY"};